<ng-container
  *ngIf="
    location.controllers.$values
      | getControllerByIndex
        : propToDisplay.propInfo.controllerIndex as controllerAtIndex
  "
>
  <ng-container
    *ngIf="
      controllerAtIndex
        | findPropertyByCode
          : propToDisplay.propInfo.codeFrom
          : propToDisplay.propInfo.codeTo
          : updated
          : displaySize as windowProperties
    "
  >
    <ng-container
      *ngIf="
        controllerAtIndex
          | findProperty
            : Property.isIgnoreWindow
            : null
            : true as ignoreWindowProps
      "
    >
      <!-- WINDOW IGNORED -->
      @if(ignoreWindowProps | propIsActive) {
      <div
        [title]="windowProperties[0]?.name + ' ' + 'ignored' | translate"
        [ngClass]="[
          displaySize === 'minimal' ? 'flex-row-center-full' : 'flex-row'
        ]"
        class="full-height ignored"
      >
        <div
          class="icon-background-off"
          style="margin-left: inherit"
          [ngClass]="[propToDisplay.propInfo.inactiveIcon]"
        ></div>

        <div
          *ngIf="displaySize === 'large'"
          class="status-text-off status-text-ellipsis"
        >
          {{ windowProperties[0]?.name + " " + "ignored" | translate }}
        </div>
      </div>
      }
      <!-- WINDOW ACTIVE -->
      @else if(windowProperties | propIsActive) {
      <div
        [title]="windowProperties[0]?.name + ' ' + 'active' | translate"
        [ngClass]="[
          displaySize === 'minimal' ? 'flex-row-center-full' : 'flex-row'
        ]"
        class="full-height"
      >
        <div
          class="icon-background-on"
          style="margin-left: inherit"
          [ngClass]="[propToDisplay.propInfo.activeIcon]"
        ></div>

        <div
          *ngIf="displaySize === 'large'"
          class="status-text-on status-text-ellipsis"
        >
          {{ windowProperties[0]?.name + " " + "active" | translate }}
        </div>
      </div>
      } @else {
      <!-- WINDOW NOT ACTIVE -->
      <div
        [title]="windowProperties[0]?.name + ' ' + 'inactive' | translate"
        [ngClass]="[
          displaySize === 'minimal' ? 'flex-row-center-full' : 'flex-row'
        ]"
        class="full-height"
      >
        <div
          class="icon-background-off"
          style="margin-left: inherit"
          [ngClass]="[propToDisplay.propInfo.inactiveIcon]"
        ></div>
        <div
          *ngIf="displaySize === 'large'"
          class="status-text-off status-text-ellipsis"
        >
          {{ windowProperties[0]?.name + " " + "inactive" | translate }}
        </div>
      </div>
      }
    </ng-container>
  </ng-container>
</ng-container>
